import { render, staticRenderFns } from "./KefuData.vue?vue&type=template&id=55467060&scoped=true"
import script from "./KefuData.vue?vue&type=script&lang=js"
export * from "./KefuData.vue?vue&type=script&lang=js"
import style0 from "./KefuData.vue?vue&type=style&index=0&id=55467060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55467060",
  null
  
)

export default component.exports